module.exports = __webpack_public_path__ + "img/fopeaInsultosX6.4fa64794.jpg";